import React from 'react';

import { Field } from 'react-final-form';
import { useDispatch } from 'react-redux';

import MediaBlocks from 'components/Pages/FileLibrary/Common/MediaBlocks';
import AddMinusButton from 'components/shared/AddMinusButton';
import Text from 'components/shared/Typography/Text';
import { editThunk } from 'store/assets/thunks';
import { ASSET_SIZE_TYPES, MEDIA_MIME_TYPES } from 'utils/asset';

import styles from './index.module.css';

import Upload from './index';

function Images({ files = [], form, onOpenModal, onDelete, onReorder, name }) {
  const dispatch = useDispatch();
  const type = 'media';
  const handleEdit = (asset) => {
    dispatch(
      editThunk({
        id: asset.id,
        modalTitle: 'Edit Photo',
        onDelete: (asset) => onDelete(type)(asset, form),
      }),
    );
  };

  return (
    <>
      <div className={styles.photosWrapper}>
        <div className={styles.photoLabel}>
          <Text type="brandon" size="regular">
            Photos
          </Text>
        </div>

        {!files.length ? (
          <Upload
            onOpenModal={() => onOpenModal(type, form)}
            allowedMimeTypes={MEDIA_MIME_TYPES}
            contentType="photos"
            buttonActionType="add"
            className={styles.upload}
          />
        ) : (
          <>
            <div className={styles.photos}>
              <MediaBlocks
                assets={files}
                onLoadChunk={() => false}
                onClick={handleEdit}
                onDelete={(asset) => onDelete(type)(asset, form)}
                onReorder={onReorder}
                onCheckUpdatable={() => true}
                sm
                imageSizeType={ASSET_SIZE_TYPES.PREVIEW}
              />
            </div>

            <AddMinusButton onClick={() => onOpenModal(type, form)} />
          </>
        )}
      </div>

      <Field name={name} render={() => null} />
    </>
  );
}

export default Images;
